/**
 * SectionHeader Component
 *
 * Reusable header component for major sections with gradient background.
 */

import React from "react";
import { commonStyles, gradients, colors } from "../styles";

const SectionHeader = ({ title, subtitle, variant = "primary", children }) => {
  const backgroundMap = {
    primary: gradients.primary,
    danger: gradients.danger,
  };

  const borderColorMap = {
    primary: colors.accent,
    danger: "#a71d2a",
  };

  return (
    <div
      style={{
        ...commonStyles.sectionHeader,
        background: backgroundMap[variant] || backgroundMap.primary,
        borderBottomColor: borderColorMap[variant] || borderColorMap.primary,
      }}
    >
      <div>
        <h2
          style={{
            margin: subtitle ? "0 0 6px 0" : 0,
            fontSize: "20px",
            fontWeight: 700,
            color: colors.white,
          }}
        >
          {title}
        </h2>
        {subtitle && (
          <p
            style={{
              margin: 0,
              fontSize: "13px",
              color: "rgba(255,255,255,0.85)",
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
      {children}
    </div>
  );
};

export default SectionHeader;
